import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IBooking, IFilterBooking } from "../bookingModel";
import moment from "moment";

export const getAllBookings = createAsyncThunk(
  "Booking/FindAllBooking",
  async (formData: IFilterBooking) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Booking/FindAllBooking`,
        formData,
      );
      return response.data?.Data || [];
    } catch (error: any) {
      console.error("Error Fetching Bookings:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createBooking = createAsyncThunk(
  "Booking/InsertBooking",
  async (BookingData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Booking/InsertBooking`,
        BookingData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating booking:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateBooking = createAsyncThunk(
  "Booking/UpdateBooking",
  async (BookingData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Booking/UpdateBooking`,
        BookingData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating booking:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteBooking = createAsyncThunk(
  "Booking/DeleteBooking",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Booking/DeleteBooking`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting booking:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getBookingByID = createAsyncThunk(
  "Booking/FindByIDBooking",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Booking/FindByIDBooking`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ...result,
        BookingDate: result?.BookingDate
          ? moment(result?.BookingDate, "YYYY-MM-DD").toDate()
          : "",
        CheckinDate: result?.CheckinDate
          ? moment(result?.CheckinDate, "YYYY-MM-DD").toDate()
          : "",
        CheckinTime: result?.CheckinTime
          ? moment(result?.CheckinTime, ["HH:mm:ss", "HH:mm A"]).toDate()
          : "",
      } as IBooking;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching booking details:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const ValidateReferalCode = createAsyncThunk(
  "Booking/FindByReferalCodeBooking",
  async (ReferalCode: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Booking/FindByReferalCodeBooking`,
        { ReferalCode },
      );
      return response.data?.Data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error validating referal code:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
